
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as printCFSIt5i1m_QEZgiWiLtxEgj2EqirOup2DcszldqIfkUMeta } from "/app/pages/portfolio/property/[propertyId]/print.vue?macro=true";
import { default as _91propertyId_930CI0l93fSxNf0QVSpjk6HMLDXWx4XyiHWQz4DDoU2NYMeta } from "/app/pages/portfolio/property/[propertyId].vue?macro=true";
import { default as datamappingZJmlTkd0VHccM0wtstRIg_5r9dwXJNDF7OS70DsYFL8Meta } from "/app/pages/datamanagement/datamapping.vue?macro=true";
import { default as _91portfolioId_93NK7CyweArchQhrjerISCwU_Mb65q5wnQ4jddVm8GkxkMeta } from "/app/pages/portfolio/[portfolioId].vue?macro=true";
import { default as print6uUuyU8UjrqAorMcD7dnN0BUCO2UB6mr1SJ9sUTGeIQMeta } from "/app/pages/reports/[layoutId]/print.vue?macro=true";
import { default as _91layoutId_93H74mXsC7LjO2YC_UMTdhx88hpT0hHZLjRkk8x7J7PvcMeta } from "/app/pages/reports/[layoutId].vue?macro=true";
import { default as indexvhfhWVotO_6VvDOq_cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
export default [
  {
    name: "datamanagement-integrationhub-integrationName",
    path: "/datamanagement/integrationhub/:integrationName()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/integrationhub/[integrationName].vue")
  },
  {
    name: "datamanagement-pipelines-pipelineId",
    path: "/datamanagement/pipelines/:pipelineId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/[pipelineId].vue")
  },
  {
    name: _91propertyId_930CI0l93fSxNf0QVSpjk6HMLDXWx4XyiHWQz4DDoU2NYMeta?.name,
    path: "/portfolio/property/:propertyId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId].vue"),
    children: [
  {
    name: "portfolio-property-propertyId-balance",
    path: "balance",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/balance.vue")
  },
  {
    name: "portfolio-property-propertyId-capexes",
    path: "capexes",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/capexes.vue")
  },
  {
    name: "portfolio-property-propertyId-opex",
    path: "opex",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/opex.vue")
  },
  {
    name: "portfolio-property-propertyId-print",
    path: "print",
    meta: { ...(printCFSIt5i1m_QEZgiWiLtxEgj2EqirOup2DcszldqIfkUMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/portfolio/property/[propertyId]/print.vue")
  },
  {
    name: "portfolio-property-propertyId-sales",
    path: "sales",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/sales.vue")
  },
  {
    name: "portfolio-property-propertyId-units",
    path: "units",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/units.vue")
  },
  {
    name: "portfolio-property-propertyId-valuations",
    path: "valuations",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/valuations.vue")
  },
  {
    name: "portfolio-property-propertyId",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/property/[propertyId]/index.vue")
  }
]
  },
  {
    name: "portfolio-tenancy-tenancyId",
    path: "/portfolio/tenancy/:tenancyId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId].vue"),
    children: [
  {
    name: "portfolio-tenancy-tenancyId-account-statement",
    path: "account-statement",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/account-statement/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-arrears",
    path: "arrears",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/arrears/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-capexes",
    path: "capexes",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/capexes/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-overview",
    path: "overview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/overview/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-sales",
    path: "sales",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/sales/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-tenant",
    path: "tenant",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/tenant/index.vue")
  },
  {
    name: "portfolio-tenancy-tenancyId-valuations",
    path: "valuations",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/tenancy/[tenancyId]/valuations/index.vue")
  }
]
  },
  {
    name: "reports-sets-setId",
    path: "/reports/sets/:setId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/sets/[setId].vue")
  },
  {
    name: datamappingZJmlTkd0VHccM0wtstRIg_5r9dwXJNDF7OS70DsYFL8Meta?.name,
    path: "/datamanagement/datamapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping.vue"),
    children: [
  {
    name: "datamanagement-datamapping-account-mapping",
    path: "account-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/account-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-category-mapping",
    path: "category-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/category-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-custom-fields-mapping",
    path: "custom-fields-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/custom-fields-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-portfolio-mapping",
    path: "portfolio-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/portfolio-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-property-mapping",
    path: "property-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/property-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping-tenancy-mapping",
    path: "tenancy-mapping",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/tenancy-mapping/index.vue")
  },
  {
    name: "datamanagement-datamapping",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/datamapping/index.vue")
  }
]
  },
  {
    name: "datamanagement-integrationhub",
    path: "/datamanagement/integrationhub",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/integrationhub/index.vue")
  },
  {
    name: "datamanagement-pipelines",
    path: "/datamanagement/pipelines",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/datamanagement/pipelines/index.vue")
  },
  {
    name: _91portfolioId_93NK7CyweArchQhrjerISCwU_Mb65q5wnQ4jddVm8GkxkMeta?.name,
    path: "/portfolio/:portfolioId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId].vue"),
    children: [
  {
    name: "portfolio-portfolioId-balance",
    path: "balance",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/balance.vue")
  },
  {
    name: "portfolio-portfolioId-companies",
    path: "companies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/companies.vue")
  },
  {
    name: "portfolio-portfolioId-opex",
    path: "opex",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/opex.vue")
  },
  {
    name: "portfolio-portfolioId-properties",
    path: "properties",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/properties.vue")
  },
  {
    name: "portfolio-portfolioId-tenancies",
    path: "tenancies",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/tenancies.vue")
  },
  {
    name: "portfolio-portfolioId",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/portfolio/[portfolioId]/index.vue")
  }
]
  },
  {
    name: _91layoutId_93H74mXsC7LjO2YC_UMTdhx88hpT0hHZLjRkk8x7J7PvcMeta?.name,
    path: "/reports/:layoutId()",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/[layoutId].vue"),
    children: [
  {
    name: "reports-layoutId-print",
    path: "print",
    meta: { ...(print6uUuyU8UjrqAorMcD7dnN0BUCO2UB6mr1SJ9sUTGeIQMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/reports/[layoutId]/print.vue")
  },
  {
    name: "reports-layoutId",
    path: "",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/[layoutId]/index.vue")
  }
]
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/accounts.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/analytics/index.vue")
  },
  {
    name: "assets",
    path: "/assets",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/assets.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: { ...(indexvhfhWVotO_6VvDOq_cYkZMmeSIieYf1jIKy2UpS3yT0Meta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "canvas-reports",
    path: "/canvas-reports",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/canvas-reports/index.vue")
  },
  {
    name: "layout-preview",
    path: "/layout-preview",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/layout-preview.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta || {}), ...{"middleware":["auth0","feature-flags-hooks"]} },
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "opextracker",
    path: "/opextracker",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/opextracker.vue")
  },
  {
    name: "rentroll",
    path: "/rentroll",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/rentroll.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/reports/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["auth0","feature-flags-hooks"]},
    component: () => import("/app/pages/index.vue")
  }
]